





































import Vue from "vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import WindowsLogo from "@/components/atoms/icons/WindowsLogo.vue";
import AndroidLogo from "@/components/atoms/icons/AndroidLogo.vue";

export default Vue.extend({
  name: "TrialStepOs",
  components: { VaCard, VaButton, WindowsLogo, AndroidLogo },
  data() {
    return {
      selected: null as string | null,
    };
  },
  methods: {
    onContinue() {
      this.$emit("select", this.selected);
      this.$emit("next");
    },
  },
});
